









import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";

@Component
export default class DatalistSuggestSelector extends Mixins() {
  private static readonly maxLength: number = 256;
  static uniqueId: number = 1;

  @Prop()
  elementId: string;

  @Prop()
  identifier: string;

  @Prop()
  userCode: string;

  @Prop()
  keyword: string;

  @Watch("keyword")
  onKeywordUpdated(newValue: string, oldValue: string) {
    this.updateOptions();
  }

  @Emit("update:elementId")
  updateElementId(value: string): void {}

  data() {
    return {
      options: [] as string[],
    };
  }
  options: string[];

  mounted() {
    this.setElementId();
    this.updateOptions();
  }

  private setElementId() {
    this.updateElementId(this.identifier.toLowerCase() + DatalistSuggestSelector.uniqueId);
    DatalistSuggestSelector.uniqueId++;
  }

  async updateOptions() {
    try {
      const repository = DomainRegistry.system.getSuggestRepository();
      const result = await repository.getSuggests(this.identifier, this.userCode, this.keyword);
      this.options = result;
    } catch (e) {
      this.$warn("テキスト入力候補取得", "テキスト入力候補取得処理中にエラーが発生しました。", e);
    }
  }

  async registerSuggest(keyword: string) {
    try {
      if (keyword === "") {
        return;
      }
      if (keyword.length > DatalistSuggestSelector.maxLength) {
        this.$warn("テキスト入力候補登録", "文字列が長すぎます。");
        return;
      }
      const repository = DomainRegistry.system.getSuggestRepository();
      await repository.registerSuggest(this.identifier, this.userCode, keyword);
    } catch (e) {
      this.$warn("テキスト入力候補登録", "テキスト入力候補登録処理中にエラーが発生しました。", e);
    }
  }
}
